<template>
    <b-container fluid>
        <vue-toaster ref="toastr"></vue-toaster>
        <div :class="{blur: loading}">
            <b-row>
                <b-col>
                    <h1 class="mb-4">Система кредитования</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="8">
                    <b-card title="Информация">
                        <p>Кредиты выдаются под залог движимого и недвижимого имущества находящегося на Северном Кипре.</p>
                        <p>В каждом случае мы подходим индивидуально - сумма кредита, процентная ставка, условия и сроки кредитования подбираются при рассмотрении заявки.</p>
                    </b-card>
                </b-col>
                <b-col cols="4">
                    <b-card title="Оставить заявку">
                        <b-form @submit.prevent="sendRequest()">
                            <b-form-row>
                                <b-col cols="6">
                                    <b-form-group label="Фамилия" label-for="profile-lastname">
                                        <b-form-input id="profile-lastname" v-model.string="request.lastname" />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                    <b-form-group label="Имя" label-for="profile-firstname">
                                        <b-form-input id="profile-firstname" v-model.string="request.firstname" />
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                            <b-form-group label="E-Mail" label-for="profile-email">
                                <b-form-input id="profile-email" v-model.string="request.email" />
                            </b-form-group>
                            <b-form-group label="Skype" label-for="profile-skype">
                                <b-form-input id="profile-skype" v-model.string="request.skype" />
                            </b-form-group>
                            <b-form-group label="Текст заявки" label-for="message">
                                <b-form-textarea id="message" v-model.string="request.message" palceholder="Опишите под залог какого имущества Вы желаете получить кредит, на какой срок, на какую сумму расчитываете" :rows="3" :max-rows="6" />
                            </b-form-group>

                            <b-button type="submit" variant="primary" :disabled="!formValid">Отправить</b-button>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="loading" class="loading-container">
            <data-loading></data-loading>
        </div>
    </b-container>
</template>

<script>
    import DataLoading from '@/containers/DataLoading.vue'
    import Toastr from 'vue-toastr'

    export default {
        name: 'credits',
        components: {
            'data-loading': DataLoading,
            'vue-toaster': Toastr
        },
        data () {
            return {
                loading: false,

                request: {
                    lastname: '',
                    firstname: '',
                    email: '',
                    skype: '',
                    message: ''
                }
            }
        },
        computed: {
            formValid () {
                return this.request.email && this.request.message
            }
        },
        mounted () {
            this.loading = true
            setTimeout(() => {
                let user = this.$store.state.user['userdata']

                this.request.lastname = user.lastname
                this.request.firstname = user.firstname
                this.request.email = user.email
                this.request.skype = user.skype
                this.request.message = ''

                this.loading = false
            }, 250)
        },
        methods: {
            sendRequest () {
                this.loading = true

                this.axios.post('credits/request', this.request)
                    .then(response => {
                        if (response.data.hasOwnProperty('message') && response.data['message']) {
                            this.$refs['toastr'].i(response.data['message'])
                        }
                        this.request.message = ''
                        this.loading = false
                    })
                    .catch(() => {
                        this.$refs['toastr'].e('Возникла ошибка')
                        this.loading = false
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Credits.vue?593255a0